function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTencentMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.588236%,90.588236%,90.588236%)",
      fillOpacity: 1
    },
    d: "M 6.3125 2.4375 C 7.5625 2.4375 8.8125 2.4375 10.0625 2.4375 C 11.605469 4.0625 13.1875 5.644531 14.8125 7.1875 C 14.019531 7.667969 13.183594 8.085938 12.3125 8.4375 C 10.269531 6.480469 8.269531 4.480469 6.3125 2.4375 Z M 6.3125 2.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(4.313726%,76.47059%,38.82353%)",
      fillOpacity: 1
    },
    d: "M 10.0625 2.4375 C 12.9375 2.417969 15.8125 2.4375 18.6875 2.5 C 20.082031 2.894531 20.980469 3.792969 21.375 5.1875 C 21.4375 8.0625 21.457031 10.9375 21.4375 13.8125 C 19.8125 12.269531 18.230469 10.6875 16.6875 9.0625 C 17.0625 8.148438 17.4375 7.230469 17.8125 6.3125 C 17.617188 6.171875 17.40625 6.148438 17.1875 6.25 C 16.417969 6.625 15.625 6.9375 14.8125 7.1875 C 13.1875 5.644531 11.605469 4.0625 10.0625 2.4375 Z M 10.0625 2.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(22.352941%,45.882353%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 6.3125 2.4375 C 8.269531 4.480469 10.269531 6.480469 12.3125 8.4375 C 11.582031 8.90625 10.875 9.40625 10.1875 9.9375 C 9.601562 10.585938 9.082031 11.296875 8.625 12.0625 C 7.613281 13.878906 6.777344 15.753906 6.125 17.6875 C 8.714844 16.929688 11.152344 15.785156 13.4375 14.25 C 13.589844 14.121094 13.714844 13.972656 13.8125 13.8125 C 14.40625 13.175781 14.90625 12.46875 15.3125 11.6875 C 16.09375 12.28125 16.820312 12.945312 17.5 13.6875 C 17.582031 13.769531 17.582031 13.855469 17.5 13.9375 C 14.996094 16.421875 12.515625 18.921875 10.0625 21.4375 C 8.480469 21.457031 6.894531 21.4375 5.3125 21.375 C 3.875 20.9375 2.9375 20 2.5 18.5625 C 2.417969 14.105469 2.417969 9.644531 2.5 5.1875 C 3.121094 3.378906 4.394531 2.460938 6.3125 2.4375 Z M 6.3125 2.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(96.470588%,29.411766%,7.450981%)",
      fillOpacity: 1
    },
    d: "M 16.6875 9.0625 C 16.265625 9.949219 15.804688 10.824219 15.3125 11.6875 C 14.90625 12.46875 14.40625 13.175781 13.8125 13.8125 C 12.734375 12.503906 11.546875 11.296875 10.25 10.1875 C 10.191406 10.113281 10.171875 10.03125 10.1875 9.9375 C 10.875 9.40625 11.582031 8.90625 12.3125 8.4375 C 13.183594 8.085938 14.019531 7.667969 14.8125 7.1875 C 15.625 6.9375 16.417969 6.625 17.1875 6.25 C 17.40625 6.148438 17.617188 6.171875 17.8125 6.3125 C 17.4375 7.230469 17.0625 8.148438 16.6875 9.0625 Z M 16.6875 9.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.196079%,90.196079%,90.588236%)",
      fillOpacity: 1
    },
    d: "M 16.6875 9.0625 C 18.230469 10.6875 19.8125 12.269531 21.4375 13.8125 C 21.4375 15.0625 21.4375 16.3125 21.4375 17.5625 C 20.835938 17.023438 20.253906 16.460938 19.6875 15.875 C 19.5625 15.792969 19.4375 15.792969 19.3125 15.875 C 17.476562 17.703125 15.683594 19.554688 13.9375 21.4375 C 12.644531 21.4375 11.355469 21.4375 10.0625 21.4375 C 12.515625 18.921875 14.996094 16.421875 17.5 13.9375 C 17.582031 13.855469 17.582031 13.769531 17.5 13.6875 C 16.820312 12.945312 16.09375 12.28125 15.3125 11.6875 C 15.804688 10.824219 16.265625 9.949219 16.6875 9.0625 Z M 16.6875 9.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.823529%,98.823529%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 10.1875 9.9375 C 10.171875 10.03125 10.191406 10.113281 10.25 10.1875 C 11.546875 11.296875 12.734375 12.503906 13.8125 13.8125 C 13.714844 13.972656 13.589844 14.121094 13.4375 14.25 C 11.152344 15.785156 8.714844 16.929688 6.125 17.6875 C 6.777344 15.753906 7.613281 13.878906 8.625 12.0625 C 9.082031 11.296875 9.601562 10.585938 10.1875 9.9375 Z M 10.1875 9.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(76.078433%,76.078433%,76.078433%)",
      fillOpacity: 1
    },
    d: "M 21.4375 17.5625 C 21.414062 19.480469 20.5 20.75 18.6875 21.375 C 17.105469 21.4375 15.519531 21.457031 13.9375 21.4375 C 15.683594 19.554688 17.476562 17.703125 19.3125 15.875 C 19.4375 15.792969 19.5625 15.792969 19.6875 15.875 C 20.253906 16.460938 20.835938 17.023438 21.4375 17.5625 Z M 21.4375 17.5625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTencentMaps);
export default __webpack_public_path__ + "static/media/TencentMaps.b25728b0966b18575910f68d8f5a7f80.svg";
export { ForwardRef as ReactComponent };